// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1V6sg","content":"styles_content__1lBKP"};